import React from 'react'

import AddressVerificationModal from './address-verification-modal.component'

import type { Address } from '~/types'

type Props = {
  state: {
    changedFields: Array<string> | null | undefined
    displayModal: boolean
    originalAddress: Address | null | undefined
    suggestedAddress: Address | null | undefined
    verificationStatus: string | null | undefined
  }
  reenterAddress: () => void
  acceptOriginalAddress: () => void
  acceptSuggestedAddress: () => void
}

export default function AddressVerificationModalContainer(props: Props) {
  const {
    state: {
      changedFields,
      displayModal,
      originalAddress,
      suggestedAddress,
      verificationStatus,
    },
    reenterAddress,
    acceptOriginalAddress,
    acceptSuggestedAddress,
  } = props

  if (
    !displayModal ||
    !verificationStatus ||
    !changedFields ||
    !suggestedAddress
  )
    return null

  return (
    <AddressVerificationModal
      verificationStatus={verificationStatus}
      changedFields={changedFields}
      suggestedAddress={suggestedAddress}
      originalAddress={originalAddress}
      acceptOriginalAddress={acceptOriginalAddress}
      acceptSuggestedAddress={acceptSuggestedAddress}
      reenterAddress={reenterAddress}
    />
  )
}
